/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Retainer_Architect_Output9Inputs */

const en_svc_retainer_architect_output9 = /** @type {(inputs: Svc_Retainer_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ops baseline`)
};

const ar_svc_retainer_architect_output9 = /** @type {(inputs: Svc_Retainer_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`خط الأساس التشغيلي`)
};

const bn_svc_retainer_architect_output9 = /** @type {(inputs: Svc_Retainer_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কার্যক্রম ভিত্তি`)
};

const de_svc_retainer_architect_output9 = /** @type {(inputs: Svc_Retainer_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ops-Basislinie`)
};

const es_svc_retainer_architect_output9 = /** @type {(inputs: Svc_Retainer_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Base de operaciones`)
};

const fr_svc_retainer_architect_output9 = /** @type {(inputs: Svc_Retainer_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Base des opérations`)
};

const pt_svc_retainer_architect_output9 = /** @type {(inputs: Svc_Retainer_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Base de operações`)
};

const zh_svc_retainer_architect_output9 = /** @type {(inputs: Svc_Retainer_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`运维基线`)
};

const tr_svc_retainer_architect_output9 = /** @type {(inputs: Svc_Retainer_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Operasyon tabanı`)
};

const ru_svc_retainer_architect_output9 = /** @type {(inputs: Svc_Retainer_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Операционный базис`)
};

const pl_svc_retainer_architect_output9 = /** @type {(inputs: Svc_Retainer_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baza operacyjna`)
};

/**
* | output |
* | --- |
* | "Ops baseline" |
*
* @param {Svc_Retainer_Architect_Output9Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_retainer_architect_output9 = /** @type {((inputs?: Svc_Retainer_Architect_Output9Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Retainer_Architect_Output9Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_retainer_architect_output9(inputs)
	if (locale === "bn") return bn_svc_retainer_architect_output9(inputs)
	if (locale === "de") return de_svc_retainer_architect_output9(inputs)
	if (locale === "es") return es_svc_retainer_architect_output9(inputs)
	if (locale === "fr") return fr_svc_retainer_architect_output9(inputs)
	if (locale === "pt") return pt_svc_retainer_architect_output9(inputs)
	if (locale === "zh") return zh_svc_retainer_architect_output9(inputs)
	if (locale === "tr") return tr_svc_retainer_architect_output9(inputs)
	if (locale === "ru") return ru_svc_retainer_architect_output9(inputs)
	if (locale === "pl") return pl_svc_retainer_architect_output9(inputs)
	return en_svc_retainer_architect_output9(inputs)
});
export { svc_retainer_architect_output9 as "svc_retainer_ARCHITECT_output" }